<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Header -->
<div
  class="fixed flex flex-0 top-0 left-0 items-center w-full h-16  pr-4 md:pr-6 dark:shadow-none dark:border-b bg-[#414141] dark:bg-transparent print:hidden tx-header">
  <div class="flex justify-start items-center w-56">
    <user></user>
  </div>
  <div class="header-logo">
    <div class="nav-brand w-56 ">
      <img src="assets/images/farma/logo-1708601600_farma.png" alt="Farma image" class="h-16 w-full object-contain"
        style="height: 80px !important; max-height: none; padding: 10px;">
    </div>
  </div>

  <div class="ml-10 font-sans text-white text-4xl uppercase"></div>
  <div class="ml-10 font-sans text-white text-4xl uppercase">
    <button matButton [matMenuTriggerFor]="menu">{{ selectedOption() }}
      <mat-icon class="text-white">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @for (warehouse of warehouses(); track warehouse.id) {
      <button mat-menu-item (click)="setWarehouse(warehouse.id)">{{warehouse.name}}</button>
      }
    </mat-menu>
  </div>

  <!-- Navigation toggle button >-->
  <button mat-icon-button (click)="toggleNavigation('mainNavigation')" class="md:hidden">
    <mat-icon [svgIcon]="'heroicons_outline:bars-3'" class="text-white"></mat-icon>
  </button> <!-- Components -->

  <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
    <!-- <search [appearance]="'bar'"></search>
    <shortcuts></shortcuts>
    <messages></messages> -->
  </div>
</div>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-[#414141] print:hidden" [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.compact"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <!-- <ng-container fuseVerticalNavigationContentHeader>
  <div class="flex items-center justify-center h-20 mt-3 mb-4">
    <img class="w-10" src="assets/images/builder/buildericone.svg" alt="Fapomed image">
  </div>
  </ng-container> -->

  <ng-container fuseVerticalNavigationFooter>
    <div class="flex justify-center items-center text-slate-400 mb-2 text-xs">v{{ version }}</div>
  </ng-container>

</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Content -->
  <div class="flex flex-col flex-auto mt-16">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>
</div>
